import * as ManifestUI from '@project44/manifest-ds';

import { IWithLoadingStatusHOCOptions, TFunctionComponent } from '../../types';
import { TypographyComponent } from './Typography.component';

export type TTypography = {
  typographyProps: Omit<ManifestUI.TypographyProps, 'children'> & {
    content: string;
  };
  config: TypographyComponent;
  highlightableConfig?: {
    searchQuery: string;
  };
} & IWithLoadingStatusHOCOptions &
  Partial<JSX.IntrinsicAttributes>;

export const Typography: TFunctionComponent<TTypography> = ({
  typographyProps,
  config,
  highlightableConfig,
}) => {
  return config.handleHighlightableContentWhenPresent({
    typographyProps,
    highlightableConfig,
  });
};
